import DisabledNodesParentTreeNode from "./DisabledNodesParentTreeNode";
import TreeNode from "./TreeNode";

export default class ArchivedCustomersParentTreeNode extends DisabledNodesParentTreeNode {
    constructor() {
        super("ac", 0);
    }

    getType() {
        return TreeNode.TYPE_ARCHIVED_CUSTOMERS_PARENT
    }
}


// WEBPACK FOOTER //
// ./web/js/hierarchySelector/tree/ArchivedCustomersParentTreeNode.js